import { Link } from "react-router-dom";
import { Car, ShoppingBag, Store, ChevronLeft, Sparkles } from "lucide-react";
import { SAR } from "../components/RiyalIcon";

const STEPS = [
  { n: "1", t: "اطلب من جوالك", d: "تصفّح المنيو واختَر ما تحب" },
  { n: "2", t: "توصل للمحل", d: "لا تنزل من سيارتك" },
  { n: "3", t: "اضغط «وصلت»", d: "الموظف يعرف مباشرة" },
  { n: "4", t: "استلم واطلع", d: "طلبك يوصل للسيارة" },
];

export default function Landing() {
  return (
    <div className="min-h-screen brand-soft">
      <header className="max-w-6xl mx-auto flex items-center justify-between px-5 py-5">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-2xl brand-grad text-white grid place-items-center font-extrabold">خ</div>
          <span className="text-xl font-extrabold" data-testid="brand-name">خِفّة</span>
        </div>
        <Link to="/login" className="pill bg-white border border-orange-200 px-4 py-2 text-sm font-medium text-orange-700 hover:bg-orange-50" data-testid="nav-login">تسجيل دخول</Link>
      </header>

      <section className="max-w-6xl mx-auto px-5 pt-6 pb-10 grid md:grid-cols-2 gap-8 items-center">
        <div className="rise-in">
          <h1 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.15]">
            اطلب من جوالك<br />
            <span className="text-orange-600">واستلم عند سيارتك</span>
          </h1>
          <p className="mt-4 text-base sm:text-lg text-gray-700 max-w-lg">
            منصة بسيطة تربط الزبون بالمطعم — بدون تطبيقات معقدة، بدون انتظار، بدون النزول من السيارة.
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link to="/demo" className="pill brand-grad text-white px-6 py-3.5 font-bold text-base tap-target inline-flex items-center gap-2 card-shadow" data-testid="cta-try-system">
              <Sparkles size={18}/> جرّب النظام <ChevronLeft size={18} />
            </Link>
            <Link to="/login" className="pill bg-white border-2 border-gray-900 px-6 py-3.5 font-bold text-base tap-target inline-flex items-center gap-2" data-testid="cta-login">
              تسجيل دخول
            </Link>
          </div>
          <div className="mt-6 flex items-center gap-5 text-sm text-gray-600">
            <div className="flex items-center gap-1.5"><Car size={16} className="text-orange-600" /> استلام عند السيارة</div>
            <div className="flex items-center gap-1.5"><Store size={16} className="text-orange-600" /> استلام من المحل</div>
            <div className="flex items-center gap-1.5"><ShoppingBag size={16} className="text-orange-600" /> توصيل ذاتي</div>
          </div>
        </div>

        <div className="rise-in relative">
          <div className="absolute -inset-6 bg-gradient-to-tr from-orange-200/40 via-amber-100/40 to-transparent rounded-[36px] blur-2xl" />
          <div className="relative rounded-[28px] overflow-hidden card-shadow border border-orange-100 bg-white">
            <img src="https://images.unsplash.com/photo-1552566626-52f8b828add9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" alt="" className="w-full h-72 object-cover" />
            <div className="p-5">
              <div className="text-xs text-gray-500">طلب #1042</div>
              <div className="mt-1 font-bold text-lg">شاورما دجاج ×2 · بطاطس ×1</div>
              <div className="mt-2 flex items-center justify-between">
                <span className="inline-flex items-center gap-1.5 text-green-700 text-sm font-medium"><Car size={16}/> العميل وصل</span>
                <span className="font-extrabold text-orange-600"><SAR>27</SAR></span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-5 py-10">
        <h2 className="text-2xl sm:text-3xl font-extrabold mb-6">كيف تشتغل خِفّة؟</h2>
        <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-4">
          {STEPS.map((s) => (
            <div key={s.n} className="bg-white rounded-2xl p-5 border border-orange-100 card-shadow" data-testid={`step-${s.n}`}>
              <div className="w-9 h-9 rounded-xl brand-grad text-white grid place-items-center font-extrabold">{s.n}</div>
              <div className="mt-3 font-bold text-lg">{s.t}</div>
              <div className="text-sm text-gray-600 mt-1">{s.d}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-5 py-10">
        <div className="rounded-3xl bg-gray-900 text-white p-8 md:p-12 grid md:grid-cols-2 gap-6 items-center">
          <div>
            <h3 className="text-3xl font-extrabold">للمطاعم والكافتيريات</h3>
            <p className="mt-3 text-gray-300">استقبل الطلبات مرتّبة على جوالك — من الموقع أو من الهاتف — وسلّم للعميل بسرعة.</p>
            <ul className="mt-5 space-y-2 text-sm">
              <li className="flex items-center gap-2"><span className="text-orange-400">✓</span> لوحة بسيطة تشتغل من الجوال</li>
              <li className="flex items-center gap-2"><span className="text-orange-400">✓</span> تعديل الأسعار في ثواني</li>
              <li className="flex items-center gap-2"><span className="text-orange-400">✓</span> إضافة طلب هاتفي بسرعة</li>
              <li className="flex items-center gap-2"><span className="text-orange-400">✓</span> ملخص مبيعات اليوم</li>
            </ul>
            <Link to="/demo" className="mt-6 inline-flex pill bg-orange-500 hover:bg-orange-600 text-white px-6 py-3.5 font-bold tap-target items-center gap-2" data-testid="cta-try-secondary">
              <Sparkles size={18}/> جرّب النظام الآن
            </Link>
          </div>
          <div className="bg-white rounded-2xl p-4 text-gray-900">
            <div className="text-sm text-gray-500 mb-2">هل أنت صاحب محل؟</div>
            <div className="text-sm text-gray-700 mb-3">للحصول على حساب حقيقي، تواصل معنا وسنقوم بإنشاء حساب مطعمك.</div>
            <Link to="/login" className="pill bg-gray-900 text-white px-4 py-2.5 text-sm font-bold inline-flex items-center gap-2">
              دخول المطعم
            </Link>
          </div>
        </div>
      </section>

      <footer className="max-w-6xl mx-auto px-5 py-8 text-center text-sm text-gray-500">
        © خِفّة — منصة الطلب واستلم عند سيارتك
      </footer>
    </div>
  );
}
